var module = 'main', name = 'main/assets/svg/confirmed-icon.svg', content = "<svg version=\"1.1\" id=\"confirmed-icon\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"383.5 293.5 25 25\" enable-background=\"new 383.5 293.5 25 25\" xml:space=\"preserve\" preserveAspectRatio=\"xMinYMid\"><g><circle fill=\"#4AC3A8\" cx=\"396\" cy=\"306\" r=\"12\"/><path fill=\"#FFFFFF\" d=\"M395,312.2c-0.3,0-0.6-0.1-0.8-0.3l-4.6-3.9c-0.5-0.4-0.6-1.2-0.1-1.7c0.4-0.5,1.2-0.6,1.7-0.1l3.6,3.1\r\n\t\tl5.8-8.8c0.4-0.6,1.1-0.7,1.7-0.3c0.6,0.4,0.7,1.1,0.3,1.7l-6.6,9.9c-0.2,0.3-0.5,0.5-0.8,0.5C395.1,312.2,395.1,312.2,395,312.2z\"/></g></svg>";
angular.module(module).run(['$templateCache', function($templateCache) {
  $templateCache.put(name, content);
}]);
module.exports = name;


//////////////////
// WEBPACK FOOTER
// ./main/assets/svg/confirmed-icon.svg
// module id = 1294
// module chunks = 0